module.exports = __webpack_public_path__ + "static/full02-d7186f421afc1cc68bdff846c0a915ea.png";